/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  TerminateBtn: {
    fontSize: '16px',
    color: '#342D3D',
    height: '60px',
    minWidth: '151px',
    border: '1px solid #342D3D',
    textTransform: 'none',
    marginRight: '16px',
    transition: 'none',
    '&:hover': {
      background: '#342D3D',
      color: '#fff',
    },
    '& svg': {
      marginRight: '6px',
      fontSize: '18px',
    },
  },
  modalBtnholder: {
    textAlign: 'left',
    padding: '8px 0 0',
  },
  modalAccptBtn: {
    background: theme.palette.primary.main,
    fontSize: '16px',
    color: '#fff',
    height: '60px',
    minWidth: '151px',
    textTransform: 'none',
    borderRadius: '10px',
  },
  innerModalAccept: {
    position: 'relative',
    '& $crossIconimg': {
      position: 'absolute',
      right: '-12px',
      top: '1px',
    },
    '& h1': {
      marginBottom: '24px',
      fontSize: '20px',
    },
    '& h2': {
      marginBottom: '28px',
      color: '#342D3D',
      fontSize: '16px',
      fontWeight: '500',
    },
    '& hr': {
      backgroundColor: '#CED1D6',
    },
  },
  crossIconimg: {},
  main: { padding: '26px 0 75px' },
  container: {
    maxWidth: '1184px',
  },

  breadcrumbsHolder: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& $serviceid': {
      marginLeft: 'auto',
      fontSize: '14px',
      color: theme.palette.primary.darkGrey,
    },
  },
  serviceid: {},
  breadcrumbs: {
    fontSize: '12px',
    '& li': {
      padding: '0',
      border: '0',
    },
    '& a': {
      color: '#1C999B',
      textDecoration: 'none',
      '& svg': {
        fontSize: '18px',
      },
    },
    '& $activelink': {
      color: '#8C9099',
    },
  },
  activelink: {},
  textGray: {},
  mobileTitlehead: {
    display: 'flex',
    itemAlign: 'center',
    position: 'relative',

    borderBottom: '3px solid #EBEEF3',
    marginBottom: '12px',
    '& > div': {
      padding: '10px 15px',
    },
    '& a': {
      color: '#342D3D',
      padding: '7px 0',
      fontWeight: '500',
      display: 'block',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none',
      },
      '& img': {
        marginRight: '13px',
      },
    },
    '& $grayArea': {
      background: '#F8F8F8',
      color: '#8C9099',
      '& p': {
        fontSize: '12px',
      },
    },
    '& $trashIcon': {
      '& img': {
        position: 'absolute',
        right: 15,
      },
    },
  },
  grayArea: {},
  trashIcon: {},

  [theme.breakpoints.up('md')]: {
    main: { padding: '20px 0' },
    formControl: {
      gridTemplateColumns: '1fr 1fr',
    },
  },
  [theme.breakpoints.down('sm')]: {
    TerminateBtn: {
      fontSize: '14px',
      minWidth: '100px',
      marginRight: '16px',
    },
    modalBtnholder: {
      '& button': {
        marginBottom: '5px',
      },
    },
    modalAccptBtn: {
      fontSize: '14px',
      height: '48px',
      minWidth: 'auto',
    },
    innerModalAccept: {
      '& $crossIconimg': {
        right: '-4px',
      },
      '& h1': {
        marginBottom: '20px',
        fontSize: '16px',
      },
      '& h2': {
        marginBottom: '18px',
        fontSize: '14px',
      },
      '& hr': {
        backgroundColor: '#CED1D6',
      },
    },
    container: {
      padding: '0',
    },
  },
  [theme.breakpoints.down('sm')]: {
    rejectAcceptBtnHolder: {
      padding: '10px',
    },
  },
  applicationNumber: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
});

export default styles;
